/**
 * Detect time-gate unlocks: was waiting_until only, now unlocked.
 * First snapshot never fires (opening a campaign must not flood the inbox).
 */

export function isWaitingUntilOnly(lockState) {
  if (!lockState?.isLocked) return false;
  const blockers = lockState.blockingTasks || [];
  if (blockers.length === 0) return false;
  return blockers.every((t) => t.reason === 'waiting_until');
}

/**
 * @param {Set<string>|null} prevWaitingIds null = first pass
 * @param {Object} lockStates
 * @param {Array} tasks
 * @returns {{ nextWaitingIds: Set<string>, unlockedTasks: Array }}
 */
export function collectWaitUnlocks(prevWaitingIds, lockStates, tasks) {
  const nextWaitingIds = new Set();
  for (const task of tasks || []) {
    if (isWaitingUntilOnly(lockStates[task.id])) {
      nextWaitingIds.add(task.id);
    }
  }

  if (prevWaitingIds == null) {
    return { nextWaitingIds, unlockedTasks: [] };
  }

  const unlockedTasks = [];
  for (const id of prevWaitingIds) {
    if (nextWaitingIds.has(id)) continue;
    const task = (tasks || []).find((t) => t.id === id);
    const ls = lockStates[id];
    if (!task || ls?.isLocked) continue;
    unlockedTasks.push(task);
  }

  return { nextWaitingIds, unlockedTasks };
}
